"use strict";

exports.__esModule = true;
var _IconMenu = require("./IconMenu");
Object.keys(_IconMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IconMenu[key]) return;
  exports[key] = _IconMenu[key];
});